/**
 * A custom error for when something goes wrong with the internals of the compiler.
 * Serious software gore territory.
 */
export class InternalCompilerError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'InternalCompilerError';

    }
}